export const POST_LOGIN = "POST_LOGIN";
export const POST_LOG_OUT = "POST_LOG_OUT";
export const POST_IS_AUTHENTICATED = "POST_IS_AUTHENTICATED";
export const UPDATE_FINGERPRINT = "UPDATE_FINGERPRINT";